import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { ShowcaseType } from '../enums/ShowcaseType'
import type { ShowcaseBranchRequestEntity } from './ShowcaseBranchRequestEntity'
import type { ShowcaseItemRequestEntity } from './ShowcaseItemRequestEntity'
import type { ShowcaseTranslationEntity } from './ShowcaseTranslationEntity'
import type { ShiftShowCaseEntity } from './ShiftShowCaseEntity'
import type { ScopeType } from '../enums/ScopeType'
import type { ShowcaseModeType } from '../enums/ShowcaseModeType'
import type { ShowcaseDesign } from '../enums/ShowcaseDesign'

export class CreateUpdateShowcaseEntity {
  channel?: ChannelMiniEntity
  branches?: Array<ShowcaseBranchRequestEntity> | null
  items?: Array<ShowcaseItemRequestEntity> | null
  type?: ShowcaseType
  disabled?: boolean
  scopeType?: ScopeType
  translations?: Array<ShowcaseTranslationEntity> | null
  showcaseShiftDays?: Array<ShiftShowCaseEntity> | null
  showcasePerBranch?: number
  isShiftIgnored?: boolean
  design?: ShowcaseDesign
  mode?: ShowcaseModeType
}
